import caredevo from '../apis/caredevo';
import {
    //Analytic
    FETCH_WARNING,
    FETCH_DUE,
    //Authorization
    FETCH_AUTHS,
    FETCH_AUTH,
    NEW_AUTH,
    EDIT_AUTH,
    DELETE_AUTH,
    CHECK_AUTH,
    QUIT_AUTH,
    //Patients
    FETCH_PATIENTS,
    FETCH_PATIENT,
    SELECTED_PATIENT,
    EDIT_PATIENT,
    CLEAR_PATIENT,
    //Vaccinations
    FETCH_VACCINATIONS,
    FETCH_VACCINATION,
    NEW_VACCINATION,
    EDIT_VACCINATION,
    DELETE_VACCINATION,
    //Medications
    FETCH_MEDICATIONS,
    FETCH_MEDICATION,
    NEW_MEDICATION,
    EDIT_MEDICATION,
    DELETE_MEDICATION,
    //Todo
    FETCH_TODOS,
    FETCH_TODO,
    NEW_TODO,
    EDIT_TODO,
    DELETE_TODO,
    //History
    FETCH_HISTORIES,
    FETCH_HISTORY,
    NEW_HISTORY,
    EDIT_HISTORY,
    DELETE_HISTORY,
    //OtherDetail
    FETCH_OTHERDETAILS,
    FETCH_OTHERDETAIL,
    NEW_OTHERDETAIL,
    EDIT_OTHERDETAIL,
    DELETE_OTHERDETAIL,
    //Preventive
    FETCH_PREVENTIVES,
    FETCH_PREVENTIVE,
    NEW_PREVENTIVE,
    EDIT_PREVENTIVE,
    DELETE_PREVENTIVE,
    //HA Details
    FETCH_HA_DETAILS,
    FETCH_HA_DETAIL,
    NEW_HA_DETAIL,
    EDIT_HA_DETAIL,
    DELETE_HA_DETAIL,
    //HA Exams
    FETCH_HA_EXAMS,
    FETCH_HA_EXAM,
    NEW_HA_EXAM,
    EDIT_HA_EXAM,
    DELETE_HA_EXAM,
    //reminder
    FETCH_REMINDERS,
    FETCH_REMINDER,
    NEW_REMINDER,
    EDIT_REMINDER,
    DELETE_REMINDER,
    //Reaction
    FETCH_REACTIONS,
    FETCH_REACTION,
    NEW_REACTION,
    EDIT_REACTION,
    DELETE_REACTION,
    //Requestpath
    FETCH_REQUESTPATHS,
    FETCH_REQUESTPATH,
    NEW_REQUESTPATH,
    EDIT_REQUESTPATH,
    DELETE_REQUESTPATH,
    //Visit
    FETCH_VISITS,
    FETCH_VISIT,
    NEW_VISIT,
    EDIT_VISIT,
    DELETE_VISIT,
    //Prescription
    FETCH_PRESCRIPTIONS,
    FETCH_PRESCRIPTION,
    NEW_PRESCRIPTION,
    EDIT_PRESCRIPTION,
    DELETE_PRESCRIPTION,
    //Familyhistory
    FETCH_FAMILYHISTORIES,
    FETCH_FAMILYHISTORY,
    NEW_FAMILYHISTORY,
    EDIT_FAMILYHISTORY,
    DELETE_FAMILYHISTORY,
    //DiseaseLib
    FETCH_DISEASELIBS,
    FETCH_DISEASELIB,
    NEW_DISEASELIB,
    EDIT_DISEASELIB,
    DELETE_DISEASELIB,
    //ArrangeLib
    FETCH_ARRANGELIBS,
    FETCH_ARRANGELIB,
    NEW_ARRANGELIB,
    EDIT_ARRANGELIB,
    DELETE_ARRANGELIB,
    //GOALLIB
    FETCH_GOALLIBS,
    FETCH_GOALLIB,
    NEW_GOALLIB,
    EDIT_GOALLIB,
    DELETE_GOALLIB,
    //EDUCATIONLIB
    FETCH_EDUCATIONLIBS,
    FETCH_EDUCATIONLIB,
    NEW_EDUCATIONLIB,
    EDIT_EDUCATIONLIB,
    DELETE_EDUCATIONLIB,
    //MONITORLIB
    FETCH_MONITORLIBS,
    FETCH_MONITORLIB,
    NEW_MONITORLIB,
    EDIT_MONITORLIB,
    DELETE_MONITORLIB,    
    //PROBLEM
    FETCH_PROBLEMS,
    FETCH_PROBLEM,
    NEW_PROBLEM,
    EDIT_PROBLEM,
    DELETE_PROBLEM,
    //GOAL
    FETCH_GOALS,
    FETCH_GOAL,
    NEW_GOAL,
    EDIT_GOAL,
    DELETE_GOAL,
    //ARRANGE
    FETCH_ARRANGES,
    FETCH_ARRANGE,
    NEW_ARRANGE,
    EDIT_ARRANGE,
    DELETE_ARRANGE,
    //EDUCATION
    FETCH_EDUCATIONS,
    FETCH_EDUCATION,
    NEW_EDUCATION,
    EDIT_EDUCATION,
    DELETE_EDUCATION,
    //MONITOR
    FETCH_MONITORS,
    FETCH_MONITOR,
    NEW_MONITOR,
    EDIT_MONITOR,
    DELETE_MONITOR,
    //USER
    FETCH_USERS,
    FETCH_USER,
    NEW_USER,
    EDIT_USER,
    DELETE_USER,
    //PERMISSION
    FETCH_PERMISSION,
    FETCH_USERPERMISSIONS,
    FETCH_PATIENTPERMISSIONS,
    NEW_PERMISSION,
    EDIT_PERMISSION,
    DELETE_PERMISSION,
    //AODHISTORY
    FETCH_AODHISTORYS,
    FETCH_AODHISTORY,
    NEW_AODHISTORY,
    EDIT_AODHISTORY,
    DELETE_AODHISTORY,
    //AODLEGAL
    FETCH_AODLEGALS,
    FETCH_AODLEGAL,
    NEW_AODLEGAL,
    EDIT_AODLEGAL,
    DELETE_AODLEGAL,
    //AODPLAN
    FETCH_AODPLANS,
    FETCH_AODPLAN,
    NEW_AODPLAN,
    EDIT_AODPLAN,
    DELETE_AODPLAN,
    //AODSUBSTANCE
    FETCH_AODSUBSTANCES,
    FETCH_AODSUBSTANCE,
    NEW_AODSUBSTANCE,
    EDIT_AODSUBSTANCE,
    DELETE_AODSUBSTANCE,
    //IMAGEEPISODE
    FETCH_IMAGEEPISODES,
    FETCH_IMAGEEPISODE,
    NEW_IMAGEEPISODE,
    EDIT_IMAGEEPISODE,
    DELETE_IMAGEEPISODE,
    //IMAGEPHOTO
    FETCH_IMAGEPHOTOS,
    FETCH_IMAGEPHOTO,
    NEW_IMAGEPHOTO,
    EDIT_IMAGEPHOTO,
    DELETE_IMAGEPHOTO,
    //MHACTION
    FETCH_MHACTIONS,
    FETCH_MHACTION,
    NEW_MHACTION,
    EDIT_MHACTION,
    DELETE_MHACTION,
    //MHFORMULATE
    FETCH_MHFORMULATES,
    FETCH_MHFORMULATE,
    NEW_MHFORMULATE,
    EDIT_MHFORMULATE,
    DELETE_MHFORMULATE,
    //MHPROFILE
    FETCH_MHPROFILES,
    FETCH_MHPROFILE,
    NEW_MHPROFILE,
    EDIT_MHPROFILE,
    DELETE_MHPROFILE,
    //MHPROVIDER
    FETCH_MHPROVIDERS,
    FETCH_MHPROVIDER,
    NEW_MHPROVIDER,
    EDIT_MHPROVIDER,
    DELETE_MHPROVIDER,
    //MHREVIEW
    FETCH_MHREVIEWS,
    FETCH_MHREVIEW,
    NEW_MHREVIEW,
    EDIT_MHREVIEW,
    DELETE_MHREVIEW,
    //MHSAFETY
    FETCH_MHSAFETYS,
    FETCH_MHSAFETY,
    NEW_MHSAFETY,
    EDIT_MHSAFETY,
    DELETE_MHSAFETY,
    //PAINEXAMINATION
    FETCH_PAINEXAMINATIONS,
    FETCH_PAINEXAMINATION,
    NEW_PAINEXAMINATION,
    EDIT_PAINEXAMINATION,
    DELETE_PAINEXAMINATION,
    //PAINHISTORY
    FETCH_PAINHISTORYS,
    FETCH_PAINHISTORY,
    NEW_PAINHISTORY,
    EDIT_PAINHISTORY,
    DELETE_PAINHISTORY,
    //PAINPSYCHOSOCIAL
    FETCH_PAINPSYCHOSOCIALS,
    FETCH_PAINPSYCHOSOCIAL,
    NEW_PAINPSYCHOSOCIAL,
    EDIT_PAINPSYCHOSOCIAL,
    DELETE_PAINPSYCHOSOCIAL,
    //PAINREVIEW
    FETCH_PAINREVIEWS,
    FETCH_PAINREVIEW,
    NEW_PAINREVIEW,
    EDIT_PAINREVIEW,
    DELETE_PAINREVIEW,
    //PAINTREATMENT
    FETCH_PAINTREATMENTS,
    FETCH_PAINTREATMENT,
    NEW_PAINTREATMENT,
    EDIT_PAINTREATMENT,
    DELETE_PAINTREATMENT,
    //OBSERVATION
    FETCH_OBSERVATIONS,
    FETCH_OBSERVATION,
    NEW_OBSERVATION,
    EDIT_OBSERVATION,
    DELETE_OBSERVATION,
    //PATHOLOGY
    FETCH_PATHOLOGYS,
    FETCH_PATHOLOGY,
    NEW_PATHOLOGY,
    EDIT_PATHOLOGY,
    DELETE_PATHOLOGY,
    //GLUCOSE
    FETCH_HOMEGLUCOSES,
    FETCH_HOMEGLUCOSE,
    NEW_HOMEGLUCOSE,
    EDIT_HOMEGLUCOSE,
    DELETE_HOMEGLUCOSE,
    //HOMEWEIGHT
    FETCH_HOMEWEIGHTS,
    FETCH_HOMEWEIGHT,
    NEW_HOMEWEIGHT,
    EDIT_HOMEWEIGHT,
    DELETE_HOMEWEIGHT,
    //BP
    FETCH_HOMEBPS,
    FETCH_HOMEBP,
    NEW_HOMEBP,
    EDIT_HOMEBP,
    DELETE_HOMEBP,
    //FLAG
    FETCH_FLAGS,
    FETCH_FLAG,
    NEW_FLAG,
    EDIT_FLAG,
    DELETE_FLAG,
    //PHOTOEXTERNAL
    FETCH_PHOTOEXTERNALS,
    FETCH_PHOTOEXTERNAL,
    NEW_PHOTOEXTERNAL,
    EDIT_PHOTOEXTERNAL,
    DELETE_PHOTOEXTERNAL,
    //PHOTOMACRO
    FETCH_PHOTOMACROS,
    FETCH_PHOTOMACRO,
    NEW_PHOTOMACRO,
    EDIT_PHOTOMACRO,
    DELETE_PHOTOMACRO,
    FETCH_SHOWMACRO,
    //PHOTODERMOSCOPY
    FETCH_PHOTODERMOSCOPYS,
    FETCH_PHOTODERMOSCOPY,
    NEW_PHOTODERMOSCOPY,
    EDIT_PHOTODERMOSCOPY,
    DELETE_PHOTODERMOSCOPY, 
    FETCH_SHOWDERMOSCOPY,
    //PHOTODISPLAY
    FETCH_PHOTODISPLAY,

   

} from './types';
///////////// ANALYTIC SECTION : Warning

//Warning
export const fetchWarning = (ptid) => async dispatch => {
    const response = await caredevo.get(`/warning/${ptid}`);
    dispatch({type: FETCH_WARNING, payload : response.data});
};
export const fetchDue = (ptid) => async dispatch => {
    const response = await caredevo.get(`/due/${ptid}`);
    dispatch({type: FETCH_DUE, payload : response.data});
};

///////////// PRIVACY SECTION : Authentication, Permission

// User
export const fetchUsers = (ptid) => async dispatch => {
    const response = await caredevo.get(`/user/patient/${ptid}`);
    dispatch({type: FETCH_USERS, payload : response.data});
};

export const fetchUser = (id) => async dispatch => {
    const response = await caredevo.get(`/user/${id}`);
    dispatch({type: FETCH_USER, payload : response.data});
};

export const newUser = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/user/add', {...formValues});
    dispatch({type: NEW_USER, payload: response.data});  
}

export const editUser = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/user/update/${id}`, {...formValues});
    dispatch({type: EDIT_USER, payload: response.data});  
}

export const deleteUser = (id) => async dispatch => {
    const response = await caredevo.delete(`/user/${id}`);
    dispatch({type: DELETE_USER, payload : response.data});
};

// Permission
export const fetchPatientPermissions = (ptid) => async dispatch => {
    const response = await caredevo.get(`/permission/patient/${ptid}`);
    dispatch({type: FETCH_PATIENTPERMISSIONS, payload : response.data});
};

// fetching all user permission
export const fetchUserPermissions = (userid) => async dispatch => {
    const response = await caredevo.get(`/permission/user/${userid}`);
    dispatch({type: FETCH_USERPERMISSIONS, payload : response.data});
};

export const fetchPermission = (id) => async dispatch => {
    const response = await caredevo.get(`/permission/${id}`);
    dispatch({type: FETCH_PERMISSION, payload : response.data});
};

export const newPermission = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/permission/add', {...formValues});
    dispatch({type: NEW_PERMISSION, payload: response.data});  
}

export const editPermission = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/permission/update/${id}`, {...formValues});
    dispatch({type: EDIT_PERMISSION, payload: response.data});  
}

export const deletePermission = (id) => async dispatch => {
    const response = await caredevo.delete(`/permission/${id}`);
    dispatch({type: DELETE_PERMISSION, payload : response.data});
};

// Auth
export const fetchAuths = () => async dispatch => {
    const response = await caredevo.get('/auth');
    dispatch({type: FETCH_AUTHS, payload : response.data});
};

export const fetchAuth = (id) => async dispatch => {
    const response = await caredevo.get(`/auth/${id}`);
    dispatch({type: FETCH_AUTH, payload : response.data});
};

export const newAuth = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/auth/add', {...formValues});
    dispatch({type: NEW_AUTH, payload: response.data});  
}

export const editAuth = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/auth/update/${id}`, {...formValues});
    dispatch({type: EDIT_AUTH, payload: response.data});  
}

export const deleteAuth = (id) => async dispatch => {
    const response = await caredevo.delete(`/auth/${id}`);
    dispatch({type: DELETE_AUTH, payload : response.data});
}

export const checkAuth = (formValues) => async dispatch => {
    const response = await caredevo.post('/auth/check', {...formValues});
    dispatch({type: CHECK_AUTH, payload: response.data});  
}

export const quitAuth = () => async dispatch => {
    const response = await caredevo.post('/auth/logout');
    dispatch({type: QUIT_AUTH, payload: response.data});  
}

//Patients
export const fetchPatients = () => async dispatch => {
    const response = await caredevo.get('/biodata');
    dispatch({type: FETCH_PATIENTS, payload : response.data});
};

export const fetchPatient = (id) => async dispatch => {
    const response = await caredevo.get(`/biodata/${id}`);
    dispatch({type: FETCH_PATIENT, payload : response.data});
};

export const selectedPatient = (id) => async dispatch => {
    const response = await caredevo.get(`/biodata/${id}`);
    dispatch({type: SELECTED_PATIENT, payload : response.data});
};

export const editPatient = (formValues, id) => async dispatch => {
    const response = await caredevo.post(`/biodata/update/${id}`, {...formValues});
    dispatch({type: EDIT_PATIENT, payload : response.data});
};

export const clearPatient = () => async dispatch => {
    dispatch({type: CLEAR_PATIENT});
}

// Vaccination
export const fetchVaccinations = (ptid) => async dispatch => {
    const response = await caredevo.get(`/vaccination/patient/${ptid}`);
    dispatch({type: FETCH_VACCINATIONS, payload : response.data});
};

export const fetchVaccination = (id) => async dispatch => {
    const response = await caredevo.get(`/vaccination/${id}`);
    dispatch({type: FETCH_VACCINATION, payload : response.data});
};

export const newVaccination = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/vaccination/add', {...formValues});
    dispatch({type: NEW_VACCINATION, payload: response.data});  
}

export const editVaccination = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/vaccination/update/${id}`, {...formValues});
    dispatch({type: EDIT_VACCINATION, payload: response.data});  
}

export const deleteVaccination = (id) => async dispatch => {
    const response = await caredevo.delete(`/vaccination/${id}`);
    dispatch({type: DELETE_VACCINATION, payload : response.data});
};


// Medication
export const fetchMedications = (ptid) => async dispatch => {
    const response = await caredevo.get(`/medication/patient/${ptid}`);
    dispatch({type: FETCH_MEDICATIONS, payload : response.data});
};

export const fetchMedication = (id) => async dispatch => {
    const response = await caredevo.get(`/medication/${id}`);
    dispatch({type: FETCH_MEDICATION, payload : response.data});
};

export const newMedication = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/medication/add', {...formValues});
    dispatch({type: NEW_MEDICATION, payload: response.data});  
}

export const editMedication = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/medication/update/${id}`, {...formValues});
    dispatch({type: EDIT_MEDICATION, payload: response.data});  
}

export const deleteMedication = (id) => async dispatch => {
    const response = await caredevo.delete(`/medication/${id}`);
    dispatch({type: DELETE_MEDICATION, payload : response.data});
};

// Todo
export const fetchTodos = (ptid) => async dispatch => {
    const response = await caredevo.get(`/todo/patient/${ptid}`);
    dispatch({type: FETCH_TODOS, payload : response.data});
};

export const fetchTodo = (id) => async dispatch => {
    const response = await caredevo.get(`/todo/${id}`);
    dispatch({type: FETCH_TODO, payload : response.data});
};

export const newTodo = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/todo/add', {...formValues});
    dispatch({type: NEW_TODO, payload: response.data});  
}

export const editTodo = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/todo/update/${id}`, {...formValues});
    dispatch({type: EDIT_TODO, payload: response.data});  
}

export const deleteTodo = (id) => async dispatch => {
    const response = await caredevo.delete(`/todo/${id}`);
    dispatch({type: DELETE_TODO, payload : response.data});
};


// History
export const fetchHistories = (ptid) => async dispatch => {
    const response = await caredevo.get(`/history/patient/${ptid}`);
    dispatch({type: FETCH_HISTORIES, payload : response.data});
};

export const fetchHistory = (id) => async dispatch => {
    const response = await caredevo.get(`/history/${id}`);
    dispatch({type: FETCH_HISTORY, payload : response.data});
};

export const newHistory = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/history/add', {...formValues});
    dispatch({type: NEW_HISTORY, payload: response.data});  
}

export const editHistory = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/history/update/${id}`, {...formValues});
    dispatch({type: EDIT_HISTORY, payload: response.data});  
}

export const deleteHistory = (id) => async dispatch => {
    const response = await caredevo.delete(`/history/${id}`);
    dispatch({type: DELETE_HISTORY, payload : response.data});
};


// Other Detail
export const fetchOtherDetails = (ptid) => async dispatch => {
    const response = await caredevo.get(`/otherdetail/patient/${ptid}`);
    dispatch({type: FETCH_OTHERDETAILS, payload : response.data});
};

export const fetchOtherDetail = (id) => async dispatch => {
    const response = await caredevo.get(`/otherdetail/${id}`);
    dispatch({type: FETCH_OTHERDETAIL, payload : response.data});
};

export const newOtherDetail = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/otherdetail/add', {...formValues});
    dispatch({type: NEW_OTHERDETAIL, payload: response.data});  
}

export const editOtherDetail = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/otherdetail/update/${id}`, {...formValues});
    dispatch({type: EDIT_OTHERDETAIL, payload: response.data});  
}

export const deleteOtherDetail = (id) => async dispatch => {
    const response = await caredevo.delete(`/otherdetail/${id}`);
    dispatch({type: DELETE_OTHERDETAIL, payload : response.data});
};


// Preventive
export const fetchPreventives = (ptid) => async dispatch => {
    const response = await caredevo.get(`/preventive/patient/${ptid}`);
    dispatch({type: FETCH_PREVENTIVES, payload : response.data});
};

export const fetchPreventive = (id) => async dispatch => {
    const response = await caredevo.get(`/preventive/${id}`);
    dispatch({type: FETCH_PREVENTIVE, payload : response.data});
};

export const newPreventive = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/preventive/add', {...formValues});
    dispatch({type: NEW_PREVENTIVE, payload: response.data});  
}

export const editPreventive = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/preventive/update/${id}`, {...formValues});
    dispatch({type: EDIT_PREVENTIVE, payload: response.data});  
}

export const deletePreventive = (id) => async dispatch => {
    const response = await caredevo.delete(`/preventive/${id}`);
    dispatch({type: DELETE_PREVENTIVE, payload : response.data});
};


// HADetail
export const fetchHADetails = (ptid) => async dispatch => {
    const response = await caredevo.get(`/ha_detail/patient/${ptid}`);
    dispatch({type: FETCH_HA_DETAILS, payload : response.data});
};

export const fetchHADetail = (id) => async dispatch => {
    const response = await caredevo.get(`/ha_detail/${id}`);
    dispatch({type: FETCH_HA_DETAIL, payload : response.data});
};

export const newHADetail = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/ha_detail/add', {...formValues});
    dispatch({type: NEW_HA_DETAIL, payload: response.data});  
}

export const editHADetail = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/ha_detail/update/${id}`, {...formValues});
    dispatch({type: EDIT_HA_DETAIL, payload: response.data});  
}

export const deleteHADetail = (id) => async dispatch => {
    const response = await caredevo.delete(`/ha_detail/${id}`);
    dispatch({type: DELETE_HA_DETAIL, payload : response.data});
};

// HAExam
export const fetchHAExams = (ptid) => async dispatch => {
    const response = await caredevo.get(`/ha_exam/patient/${ptid}`);
    dispatch({type: FETCH_HA_EXAMS, payload : response.data});
};

export const fetchHAExam = (id) => async dispatch => {
    const response = await caredevo.get(`/ha_exam/${id}`);
    dispatch({type: FETCH_HA_EXAM, payload : response.data});
};

export const newHAExam = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/ha_exam/add', {...formValues});
    dispatch({type: NEW_HA_EXAM, payload: response.data});  
}

export const editHAExam = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/ha_exam/update/${id}`, {...formValues});
    dispatch({type: EDIT_HA_EXAM, payload: response.data});  
}

export const deleteHAExam = (id) => async dispatch => {
    const response = await caredevo.delete(`/ha_exam/${id}`);
    dispatch({type: DELETE_HA_EXAM, payload : response.data});
};

// Reminder
export const fetchReminders = (ptid) => async dispatch => {
    const response = await caredevo.get(`/reminder/patient/${ptid}`);
    dispatch({type: FETCH_REMINDERS, payload : response.data});
};

export const fetchReminder = (id) => async dispatch => {
    const response = await caredevo.get(`/reminder/${id}`);
    dispatch({type: FETCH_REMINDER, payload : response.data});
};

export const newReminder = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/reminder/add', {...formValues});
    dispatch({type: NEW_REMINDER, payload: response.data});  
}

export const editReminder = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/reminder/update/${id}`, {...formValues});
    dispatch({type: EDIT_REMINDER, payload: response.data});  
}

export const deleteReminder = (id) => async dispatch => {
    const response = await caredevo.delete(`/reminder/${id}`);
    dispatch({type: DELETE_REMINDER, payload : response.data});
};

//Reaction
export const fetchReactions = (ptid) => async dispatch => {
    const response = await caredevo.get(`/reaction/patient/${ptid}`);
    dispatch({type: FETCH_REACTIONS, payload : response.data});
};

export const fetchReaction = (id) => async dispatch => {
    const response = await caredevo.get(`/reaction/${id}`);
    dispatch({type: FETCH_REACTION, payload : response.data});
};

export const newReaction = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/reaction/add', {...formValues});
    dispatch({type: NEW_REACTION, payload: response.data});  
}

export const editReaction = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/reaction/update/${id}`, {...formValues});
    dispatch({type: EDIT_REACTION, payload: response.data});  
}

export const deleteReaction = (id) => async dispatch => {
    const response = await caredevo.delete(`/reaction/${id}`);
    dispatch({type: DELETE_REACTION, payload : response.data});
};

//Requestpath
export const fetchRequestPaths = (ptid) => async dispatch => {
    const response = await caredevo.get(`/requestpath/patient/${ptid}`);
    dispatch({type: FETCH_REQUESTPATHS, payload : response.data});
};

export const fetchRequestPath = (id) => async dispatch => {
    const response = await caredevo.get(`/requestpath/${id}`);
    dispatch({type: FETCH_REQUESTPATH, payload : response.data});
};

export const newRequestPath = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/requestpath/add', {...formValues});
    dispatch({type: NEW_REQUESTPATH, payload: response.data});  
}

export const editRequestPath = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/requestpath/update/${id}`, {...formValues});
    dispatch({type: EDIT_REQUESTPATH, payload: response.data});  
}

export const deleteRequestPath = (id) => async dispatch => {
    const response = await caredevo.delete(`/requestpath/${id}`);
    dispatch({type: DELETE_REQUESTPATH, payload : response.data});
};

//Visit
export const fetchVisits = (ptid) => async dispatch => {
    const response = await caredevo.get(`/visit/patient/${ptid}`);
    dispatch({type: FETCH_VISITS, payload : response.data});
};

export const fetchVisit = (id) => async dispatch => {
    const response = await caredevo.get(`/visit/${id}`);
    dispatch({type: FETCH_VISIT, payload : response.data});
};

export const newVisit = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/visit/add', {...formValues});
    dispatch({type: NEW_VISIT, payload: response.data});  
}

export const editVisit = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/visit/update/${id}`, {...formValues});
    dispatch({type: EDIT_VISIT, payload: response.data});  
}

export const deleteVisit = (id) => async dispatch => {
    const response = await caredevo.delete(`/visit/${id}`);
    dispatch({type: DELETE_VISIT, payload : response.data});
};

//Prescription
export const fetchPrescriptions = (ptid) => async dispatch => {
    const response = await caredevo.get(`/prescription/patient/${ptid}`);
    dispatch({type: FETCH_PRESCRIPTIONS, payload : response.data});
};

export const fetchPrescription = (id) => async dispatch => {
    const response = await caredevo.get(`/prescription/${id}`);
    dispatch({type: FETCH_PRESCRIPTION, payload : response.data});
};

export const newPrescription = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/prescription/add', {...formValues});
    dispatch({type: NEW_PRESCRIPTION, payload: response.data});  
}

export const editPrescription = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/prescription/update/${id}`, {...formValues});
    dispatch({type: EDIT_PRESCRIPTION, payload: response.data});  
}

export const deletePrescription = (id) => async dispatch => {
    const response = await caredevo.delete(`/prescription/${id}`);
    dispatch({type: DELETE_PRESCRIPTION, payload : response.data});
};

//Familyhistory
export const fetchFamilyHistories = (ptid) => async dispatch => {
    const response = await caredevo.get(`/familyhistory/patient/${ptid}`);
    dispatch({type: FETCH_FAMILYHISTORIES, payload : response.data});
};

export const fetchFamilyHistory = (id) => async dispatch => {
    const response = await caredevo.get(`/familyhistory/${id}`);
    dispatch({type: FETCH_FAMILYHISTORY, payload : response.data});
};

export const newFamilyHistory = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/familyhistory/add', {...formValues});
    dispatch({type: NEW_FAMILYHISTORY, payload: response.data});  
}

export const editFamilyHistory = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/familyhistory/update/${id}`, {...formValues});
    dispatch({type: EDIT_FAMILYHISTORY, payload: response.data});  
}

export const deleteFamilyHistory = (id) => async dispatch => {
    const response = await caredevo.delete(`/familyhistory/${id}`);
    dispatch({type: DELETE_FAMILYHISTORY, payload : response.data});
};

// DiseaseLib
export const fetchDiseaseLibs = () => async dispatch => {
    const response = await caredevo.get(`/diseaselibrary`);
    dispatch({type: FETCH_DISEASELIBS, payload : response.data});
};

export const fetchDiseaseLib = (id) => async dispatch => {
    const response = await caredevo.get(`/diseaselibrary/${id}`);
    dispatch({type: FETCH_DISEASELIB, payload : response.data});
};

export const newDiseaseLib = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/diseaselibrary/add', {...formValues});
    dispatch({type: NEW_DISEASELIB, payload: response.data});  
}

export const editDiseaseLib = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/diseaselibrary/update/${id}`, {...formValues});
    dispatch({type: EDIT_DISEASELIB, payload: response.data});  
}

export const deleteDiseaseLib = (id) => async dispatch => {
    const response = await caredevo.delete(`/diseaselibrary/${id}`);
    dispatch({type: DELETE_DISEASELIB, payload : response.data});
};

// ArrangeLib
export const fetchArrangeLibs = () => async dispatch => {
    const response = await caredevo.get(`/arrangelibrary`);
    dispatch({type: FETCH_ARRANGELIBS, payload : response.data});
};

export const fetchArrangeLib = (id) => async dispatch => {
    const response = await caredevo.get(`/arrangelibrary/${id}`);
    dispatch({type: FETCH_ARRANGELIB, payload : response.data});
};

export const newArrangeLib = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/arrangelibrary/add', {...formValues});
    dispatch({type: NEW_ARRANGELIB, payload: response.data});  
}

export const editArrangeLib = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/arrangelibrary/update/${id}`, {...formValues});
    dispatch({type: EDIT_ARRANGELIB, payload: response.data});  
}

export const deleteArrangeLib = (id) => async dispatch => {
    const response = await caredevo.delete(`/arrangelibrary/${id}`);
    dispatch({type: DELETE_ARRANGELIB, payload : response.data});
};

// GoalLib
export const fetchGoalLibs = () => async dispatch => {
    const response = await caredevo.get(`/goallibrary`);
    dispatch({type: FETCH_GOALLIBS, payload : response.data});
};

export const fetchGoalLib = (id) => async dispatch => {
    const response = await caredevo.get(`/goallibrary/${id}`);
    dispatch({type: FETCH_GOALLIB, payload : response.data});
};

export const newGoalLib = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/goallibrary/add', {...formValues});
    dispatch({type: NEW_GOALLIB, payload: response.data});  
}

export const editGoalLib = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/goallibrary/update/${id}`, {...formValues});
    dispatch({type: EDIT_GOALLIB, payload: response.data});  
}

export const deleteGoalLib = (id) => async dispatch => {
    const response = await caredevo.delete(`/goallibrary/${id}`);
    dispatch({type: DELETE_GOALLIB, payload : response.data});
};

// EducationLib
export const fetchEducationLibs = () => async dispatch => {
    const response = await caredevo.get(`/educationlibrary`);
    dispatch({type: FETCH_EDUCATIONLIBS, payload : response.data});
};

export const fetchEducationLib = (id) => async dispatch => {
    const response = await caredevo.get(`/educationlibrary/${id}`);
    dispatch({type: FETCH_EDUCATIONLIB, payload : response.data});
};

export const newEducationLib = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/educationlibrary/add', {...formValues});
    dispatch({type: NEW_EDUCATIONLIB, payload: response.data});  
}

export const editEducationLib = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/educationlibrary/update/${id}`, {...formValues});
    dispatch({type: EDIT_EDUCATIONLIB, payload: response.data});  
}

export const deleteEducationLib = (id) => async dispatch => {
    const response = await caredevo.delete(`/educationlibrary/${id}`);
    dispatch({type: DELETE_EDUCATIONLIB, payload : response.data});
};

// MonitorLib
export const fetchMonitorLibs = () => async dispatch => {
    const response = await caredevo.get(`/monitorlibrary`);
    dispatch({type: FETCH_MONITORLIBS, payload : response.data});
};

export const fetchMonitorLib = (id) => async dispatch => {
    const response = await caredevo.get(`/monitorlibrary/${id}`);
    dispatch({type: FETCH_MONITORLIB, payload : response.data});
};

export const newMonitorLib = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/monitorlibrary/add', {...formValues});
    dispatch({type: NEW_MONITORLIB, payload: response.data});  
}

export const editMonitorLib = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/monitorlibrary/update/${id}`, {...formValues});
    dispatch({type: EDIT_MONITORLIB, payload: response.data});  
}

export const deleteMonitorLib = (id) => async dispatch => {
    const response = await caredevo.delete(`/monitorlibrary/${id}`);
    dispatch({type: DELETE_MONITORLIB, payload : response.data});
};

// Problem
export const fetchProblems = (ptid) => async dispatch => {
    const response = await caredevo.get(`/problem/patient/${ptid}`);
    dispatch({type: FETCH_PROBLEMS, payload : response.data});
};

export const fetchProblem = (id) => async dispatch => {
    const response = await caredevo.get(`/problem/${id}`);
    dispatch({type: FETCH_PROBLEM, payload : response.data});
};

export const newProblem = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/problem/add', {...formValues});
    dispatch({type: NEW_PROBLEM, payload: response.data});  
}

export const editProblem = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/problem/update/${id}`, {...formValues});
    dispatch({type: EDIT_PROBLEM, payload: response.data});  
}

export const deleteProblem = (id) => async dispatch => {
    const response = await caredevo.delete(`/problem/${id}`);
    dispatch({type: DELETE_PROBLEM, payload : response.data});
};

// Goal
export const fetchGoals = (ptid) => async dispatch => {
    const response = await caredevo.get(`/goal/patient/${ptid}`);
    dispatch({type: FETCH_GOALS, payload : response.data});
};

export const fetchGoal = (id) => async dispatch => {
    const response = await caredevo.get(`/goal/${id}`);
    dispatch({type: FETCH_GOAL, payload : response.data});
};

export const newGoal = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/goal/add', {...formValues});
    dispatch({type: NEW_GOAL, payload: response.data});  
}

export const editGoal = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/goal/update/${id}`, {...formValues});
    dispatch({type: EDIT_GOAL, payload: response.data});  
}

export const deleteGoal = (id) => async dispatch => {
    const response = await caredevo.delete(`/goal/${id}`);
    dispatch({type: DELETE_GOAL, payload : response.data});
};

// Arrange
export const fetchArranges = (ptid) => async dispatch => {
    const response = await caredevo.get(`/arrange/patient/${ptid}`);
    dispatch({type: FETCH_ARRANGES, payload : response.data});
};

export const fetchArrange = (id) => async dispatch => {
    const response = await caredevo.get(`/arrange/${id}`);
    dispatch({type: FETCH_ARRANGE, payload : response.data});
};

export const newArrange = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/arrange/add', {...formValues});
    dispatch({type: NEW_ARRANGE, payload: response.data});  
}

export const editArrange = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/arrange/update/${id}`, {...formValues});
    dispatch({type: EDIT_ARRANGE, payload: response.data});  
}

export const deleteArrange = (id) => async dispatch => {
    const response = await caredevo.delete(`/arrange/${id}`);
    dispatch({type: DELETE_ARRANGE, payload : response.data});
};

// Education
export const fetchEducations = (ptid) => async dispatch => {
    const response = await caredevo.get(`/education/patient/${ptid}`);
    dispatch({type: FETCH_EDUCATIONS, payload : response.data});
};

export const fetchEducation = (id) => async dispatch => {
    const response = await caredevo.get(`/education/${id}`);
    dispatch({type: FETCH_EDUCATION, payload : response.data});
};

export const newEducation = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/education/add', {...formValues});
    dispatch({type: NEW_EDUCATION, payload: response.data});  
}

export const editEducation = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/education/update/${id}`, {...formValues});
    dispatch({type: EDIT_EDUCATION, payload: response.data});  
}

export const deleteEducation = (id) => async dispatch => {
    const response = await caredevo.delete(`/education/${id}`);
    dispatch({type: DELETE_EDUCATION, payload : response.data});
};

// Monitor
export const fetchMonitors = (ptid) => async dispatch => {
    const response = await caredevo.get(`/monitor/patient/${ptid}`);
    dispatch({type: FETCH_MONITORS, payload : response.data});
};

export const fetchMonitor = (id) => async dispatch => {
    const response = await caredevo.get(`/monitor/${id}`);
    dispatch({type: FETCH_MONITOR, payload : response.data});
};

export const newMonitor = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/monitor/add', {...formValues});
    dispatch({type: NEW_MONITOR, payload: response.data});  
}

export const editMonitor = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/monitor/update/${id}`, {...formValues});
    dispatch({type: EDIT_MONITOR, payload: response.data});  
}

export const deleteMonitor = (id) => async dispatch => {
    const response = await caredevo.delete(`/monitor/${id}`);
    dispatch({type: DELETE_MONITOR, payload : response.data});
};

//////////////////////////////////// AOD Section

// AOD_History
export const fetchAODHistorys = (ptid) => async dispatch => {
    const response = await caredevo.get(`/aod_history/patient/${ptid}`);
    dispatch({type: FETCH_AODHISTORYS, payload : response.data});
};

export const fetchAODHistory = (id) => async dispatch => {
    const response = await caredevo.get(`/aod_history/${id}`);
    dispatch({type: FETCH_AODHISTORY, payload : response.data});
};

export const newAODHistory = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/aod_history/add', {...formValues});
    dispatch({type: NEW_AODHISTORY, payload: response.data});  
}

export const editAODHistory = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/aod_history/update/${id}`, {...formValues});
    dispatch({type: EDIT_AODHISTORY, payload: response.data});  
}

export const deleteAODHistory = (id) => async dispatch => {
    const response = await caredevo.delete(`/aod_history/${id}`);
    dispatch({type: DELETE_AODHISTORY, payload : response.data});
};

// AOD_Legal
export const fetchAODLegals = (ptid) => async dispatch => {
    const response = await caredevo.get(`/aod_legal/patient/${ptid}`);
    dispatch({type: FETCH_AODLEGALS, payload : response.data});
};

export const fetchAODLegal = (id) => async dispatch => {
    const response = await caredevo.get(`/aod_legal/${id}`);
    dispatch({type: FETCH_AODLEGAL, payload : response.data});
};

export const newAODLegal = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/aod_legal/add', {...formValues});
    dispatch({type: NEW_AODLEGAL, payload: response.data});  
}

export const editAODLegal = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/aod_legal/update/${id}`, {...formValues});
    dispatch({type: EDIT_AODLEGAL, payload: response.data});  
}

export const deleteAODLegal = (id) => async dispatch => {
    const response = await caredevo.delete(`/aod_legal/${id}`);
    dispatch({type: DELETE_AODLEGAL, payload : response.data});
};

// AOD_Plan
export const fetchAODPlans = (ptid) => async dispatch => {
    const response = await caredevo.get(`/aod_plan/patient/${ptid}`);
    dispatch({type: FETCH_AODPLANS, payload : response.data});
};

export const fetchAODPlan = (id) => async dispatch => {
    const response = await caredevo.get(`/aod_plan/${id}`);
    dispatch({type: FETCH_AODPLAN, payload : response.data});
};

export const newAODPlan = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/aod_plan/add', {...formValues});
    dispatch({type: NEW_AODPLAN, payload: response.data});  
}

export const editAODPlan = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/aod_plan/update/${id}`, {...formValues});
    dispatch({type: EDIT_AODPLAN, payload: response.data});  
}

export const deleteAODPlan = (id) => async dispatch => {
    const response = await caredevo.delete(`/aod_plan/${id}`);
    dispatch({type: DELETE_AODPLAN, payload : response.data});
};

// AOD_Substance
export const fetchAODSubstances = (ptid) => async dispatch => {
    const response = await caredevo.get(`/aod_substance/patient/${ptid}`);
    dispatch({type: FETCH_AODSUBSTANCES, payload : response.data});
};

export const fetchAODSubstance = (id) => async dispatch => {
    const response = await caredevo.get(`/aod_substance/${id}`);
    dispatch({type: FETCH_AODSUBSTANCE, payload : response.data});
};

export const newAODSubstance = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/aod_substance/add', {...formValues});
    dispatch({type: NEW_AODSUBSTANCE, payload: response.data});  
}

export const editAODSubstance = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/aod_substance/update/${id}`, {...formValues});
    dispatch({type: EDIT_AODSUBSTANCE, payload: response.data});  
}

export const deleteAODSubstance = (id) => async dispatch => {
    const response = await caredevo.delete(`/aod_substance/${id}`);
    dispatch({type: DELETE_AODSUBSTANCE, payload : response.data});
};

//////////////////////Image Section

// Image_Episode
export const fetchImageEpisodes = (ptid) => async dispatch => {
    const response = await caredevo.get(`/image_episode/patient/${ptid}`);
    dispatch({type: FETCH_IMAGEEPISODES, payload : response.data});
};

export const fetchImageEpisode = (id) => async dispatch => {
    const response = await caredevo.get(`/image_episode/${id}`);
    dispatch({type: FETCH_IMAGEEPISODE, payload : response.data});
};

export const newImageEpisode = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/image_episode/add', {...formValues});
    dispatch({type: NEW_IMAGEEPISODE, payload: response.data});  
}

export const editImageEpisode = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/image_episode/update/${id}`, {...formValues});
    dispatch({type: EDIT_IMAGEEPISODE, payload: response.data});  
}

export const deleteImageEpisode = (id) => async dispatch => {
    const response = await caredevo.delete(`/image_episode/${id}`);
    dispatch({type: DELETE_IMAGEEPISODE, payload : response.data});
};

// Image_Photo
export const fetchImagePhotos = (ptid) => async dispatch => {
    const response = await caredevo.get(`/image_photo/patient/${ptid}`);
    dispatch({type: FETCH_IMAGEPHOTOS, payload : response.data});
};

export const fetchImagePhoto = (id) => async dispatch => {
    const response = await caredevo.get(`/image_photo/${id}`);
    dispatch({type: FETCH_IMAGEPHOTO, payload : response.data});
};

export const newImagePhoto = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/image_photo/add', {...formValues});
    dispatch({type: NEW_IMAGEPHOTO, payload: response.data});  
}

export const editImagePhoto = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/image_photo/update/${id}`, {...formValues});
    dispatch({type: EDIT_IMAGEPHOTO, payload: response.data});  
}

export const deleteImagePhoto = (id) => async dispatch => {
    const response = await caredevo.delete(`/image_photo/${id}`);
    dispatch({type: DELETE_IMAGEPHOTO, payload : response.data});
};

///////////////////////////////// Mental Health Section

// MH_Action
export const fetchMHActions = (ptid) => async dispatch => {
    const response = await caredevo.get(`/mh_action/patient/${ptid}`);
    dispatch({type: FETCH_MHACTIONS, payload : response.data});
};

export const fetchMHAction = (id) => async dispatch => {
    const response = await caredevo.get(`/mh_action/${id}`);
    dispatch({type: FETCH_MHACTION, payload : response.data});
};

export const newMHAction = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/mh_action/add', {...formValues});
    dispatch({type: NEW_MHACTION, payload: response.data});  
}

export const editMHAction = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/mh_action/update/${id}`, {...formValues});
    dispatch({type: EDIT_MHACTION, payload: response.data});  
}

export const deleteMHAction = (id) => async dispatch => {
    const response = await caredevo.delete(`/mh_action/${id}`);
    dispatch({type: DELETE_MHACTION, payload : response.data});
};

// MH_Formulate
export const fetchMHFormulates = (ptid) => async dispatch => {
    const response = await caredevo.get(`/mh_formulate/patient/${ptid}`);
    dispatch({type: FETCH_MHFORMULATES, payload : response.data});
};

export const fetchMHFormulate = (id) => async dispatch => {
    const response = await caredevo.get(`/mh_formulate/${id}`);
    dispatch({type: FETCH_MHFORMULATE, payload : response.data});
};

export const newMHFormulate = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/mh_formulate/add', {...formValues});
    dispatch({type: NEW_MHFORMULATE, payload: response.data});  
}

export const editMHFormulate = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/mh_formulate/update/${id}`, {...formValues});
    dispatch({type: EDIT_MHFORMULATE, payload: response.data});  
}

export const deleteMHFormulate = (id) => async dispatch => {
    const response = await caredevo.delete(`/mh_formulate/${id}`);
    dispatch({type: DELETE_MHFORMULATE, payload : response.data});
};

// MH_Profile
export const fetchMHProfiles = (ptid) => async dispatch => {
    const response = await caredevo.get(`/mh_profile/patient/${ptid}`);
    dispatch({type: FETCH_MHPROFILES, payload : response.data});
};

export const fetchMHProfile = (id) => async dispatch => {
    const response = await caredevo.get(`/mh_profile/${id}`);
    dispatch({type: FETCH_MHPROFILE, payload : response.data});
};

export const newMHProfile = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/mh_profile/add', {...formValues});
    dispatch({type: NEW_MHPROFILE, payload: response.data});  
}

export const editMHProfile = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/mh_profile/update/${id}`, {...formValues});
    dispatch({type: EDIT_MHPROFILE, payload: response.data});  
}

export const deleteMHProfile = (id) => async dispatch => {
    const response = await caredevo.delete(`/mh_profile/${id}`);
    dispatch({type: DELETE_MHPROFILE, payload : response.data});
};

// MH_Provider
export const fetchMHProviders = (ptid) => async dispatch => {
    const response = await caredevo.get(`/mh_provider/patient/${ptid}`);
    dispatch({type: FETCH_MHPROVIDERS, payload : response.data});
};

export const fetchMHProvider = (id) => async dispatch => {
    const response = await caredevo.get(`/mh_provider/${id}`);
    dispatch({type: FETCH_MHPROVIDER, payload : response.data});
};

export const newMHProvider = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/mh_provider/add', {...formValues});
    dispatch({type: NEW_MHPROVIDER, payload: response.data});  
}

export const editMHProvider = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/mh_provider/update/${id}`, {...formValues});
    dispatch({type: EDIT_MHPROVIDER, payload: response.data});  
}

export const deleteMHProvider = (id) => async dispatch => {
    const response = await caredevo.delete(`/mh_provider/${id}`);
    dispatch({type: DELETE_MHPROVIDER, payload : response.data});
};

// MH_Review
export const fetchMHReviews = (ptid) => async dispatch => {
    const response = await caredevo.get(`/mh_review/patient/${ptid}`);
    dispatch({type: FETCH_MHREVIEWS, payload : response.data});
};

export const fetchMHReview = (id) => async dispatch => {
    const response = await caredevo.get(`/mh_review/${id}`);
    dispatch({type: FETCH_MHREVIEW, payload : response.data});
};

export const newMHReview = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/mh_review/add', {...formValues});
    dispatch({type: NEW_MHREVIEW, payload: response.data});  
}

export const editMHReview = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/mh_review/update/${id}`, {...formValues});
    dispatch({type: EDIT_MHREVIEW, payload: response.data});  
}

export const deleteMHReview = (id) => async dispatch => {
    const response = await caredevo.delete(`/mh_review/${id}`);
    dispatch({type: DELETE_MHREVIEW, payload : response.data});
};

// MH_Safety
export const fetchMHSafetys = (ptid) => async dispatch => {
    const response = await caredevo.get(`/mh_safety/patient/${ptid}`);
    dispatch({type: FETCH_MHSAFETYS, payload : response.data});
};

export const fetchMHSafety = (id) => async dispatch => {
    const response = await caredevo.get(`/mh_safety/${id}`);
    dispatch({type: FETCH_MHSAFETY, payload : response.data});
};

export const newMHSafety = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/mh_safety/add', {...formValues});
    dispatch({type: NEW_MHSAFETY, payload: response.data});  
}

export const editMHSafety = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/mh_safety/update/${id}`, {...formValues});
    dispatch({type: EDIT_MHSAFETY, payload: response.data});  
}

export const deleteMHSafety = (id) => async dispatch => {
    const response = await caredevo.delete(`/mh_safety/${id}`);
    dispatch({type: DELETE_MHSAFETY, payload : response.data});
};

// Pain_Examination
export const fetchPainExaminations = (ptid) => async dispatch => {
    const response = await caredevo.get(`/pain_examination/patient/${ptid}`);
    dispatch({type: FETCH_PAINEXAMINATIONS, payload : response.data});
};

export const fetchPainExamination = (id) => async dispatch => {
    const response = await caredevo.get(`/pain_examination/${id}`);
    dispatch({type: FETCH_PAINEXAMINATION, payload : response.data});
};

export const newPainExamination = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/pain_examination/add', {...formValues});
    dispatch({type: NEW_PAINEXAMINATION, payload: response.data});  
}

export const editPainExamination = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/pain_examination/update/${id}`, {...formValues});
    dispatch({type: EDIT_PAINEXAMINATION, payload: response.data});  
}

export const deletePainExamination = (id) => async dispatch => {
    const response = await caredevo.delete(`/pain_examination/${id}`);
    dispatch({type: DELETE_PAINEXAMINATION, payload : response.data});
};

// Pain_History
export const fetchPainHistorys = (ptid) => async dispatch => {
    const response = await caredevo.get(`/pain_history/patient/${ptid}`);
    dispatch({type: FETCH_PAINHISTORYS, payload : response.data});
};

export const fetchPainHistory = (id) => async dispatch => {
    const response = await caredevo.get(`/pain_history/${id}`);
    dispatch({type: FETCH_PAINHISTORY, payload : response.data});
};

export const newPainHistory = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/pain_history/add', {...formValues});
    dispatch({type: NEW_PAINHISTORY, payload: response.data});  
}

export const editPainHistory = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/pain_history/update/${id}`, {...formValues});
    dispatch({type: EDIT_PAINHISTORY, payload: response.data});  
}

export const deletePainHistory = (id) => async dispatch => {
    const response = await caredevo.delete(`/pain_history/${id}`);
    dispatch({type: DELETE_PAINHISTORY, payload : response.data});
};

// Pain_Psychosocial
export const fetchPainPsychoSocials = (ptid) => async dispatch => {
    const response = await caredevo.get(`/pain_psychosocial/patient/${ptid}`);
    dispatch({type: FETCH_PAINPSYCHOSOCIALS, payload : response.data});
};

export const fetchPainPsychoSocial = (id) => async dispatch => {
    const response = await caredevo.get(`/pain_psychosocial/${id}`);
    dispatch({type: FETCH_PAINPSYCHOSOCIAL, payload : response.data});
};

export const newPainPsychoSocial = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/pain_psychosocial/add', {...formValues});
    dispatch({type: NEW_PAINPSYCHOSOCIAL, payload: response.data});  
}

export const editPainPsychoSocial = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/pain_psychosocial/update/${id}`, {...formValues});
    dispatch({type: EDIT_PAINPSYCHOSOCIAL, payload: response.data});  
}

export const deletePainPsychoSocial = (id) => async dispatch => {
    const response = await caredevo.delete(`/pain_psychosocial/${id}`);
    dispatch({type: DELETE_PAINPSYCHOSOCIAL, payload : response.data});
};

// Pain_Review
export const fetchPainReviews = (ptid) => async dispatch => {
    const response = await caredevo.get(`/pain_review/patient/${ptid}`);
    dispatch({type: FETCH_PAINREVIEWS, payload : response.data});
};

export const fetchPainReview = (id) => async dispatch => {
    const response = await caredevo.get(`/pain_review/${id}`);
    dispatch({type: FETCH_PAINREVIEW, payload : response.data});
};

export const newPainReview = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/pain_review/add', {...formValues});
    dispatch({type: NEW_PAINREVIEW, payload: response.data});  
}

export const editPainReview = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/pain_review/update/${id}`, {...formValues});
    dispatch({type: EDIT_PAINREVIEW, payload: response.data});  
}

export const deletePainReview = (id) => async dispatch => {
    const response = await caredevo.delete(`/pain_review/${id}`);
    dispatch({type: DELETE_PAINREVIEW, payload : response.data});
};

// Pain_Treatment
export const fetchPainTreatments = (ptid) => async dispatch => {
    const response = await caredevo.get(`/pain_treatment/patient/${ptid}`);
    dispatch({type: FETCH_PAINTREATMENTS, payload : response.data});
};

export const fetchPainTreatment = (id) => async dispatch => {
    const response = await caredevo.get(`/pain_treatment/${id}`);
    dispatch({type: FETCH_PAINTREATMENT, payload : response.data});
};

export const newPainTreatment = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/pain_treatment/add', {...formValues});
    dispatch({type: NEW_PAINTREATMENT, payload: response.data});  
}

export const editPainTreatment = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/pain_treatment/update/${id}`, {...formValues});
    dispatch({type: EDIT_PAINTREATMENT, payload: response.data});  
}

export const deletePainTreatment = (id) => async dispatch => {
    const response = await caredevo.delete(`/pain_treatment/${id}`);
    dispatch({type: DELETE_PAINTREATMENT, payload : response.data});
};

// Observation
export const fetchObservations = (ptid) => async dispatch => {
    const response = await caredevo.get(`/observation/patient/${ptid}`);
    dispatch({type: FETCH_OBSERVATIONS, payload : response.data});
};

export const fetchObservation = (id) => async dispatch => {
    const response = await caredevo.get(`/observation/${id}`);
    dispatch({type: FETCH_OBSERVATION, payload : response.data});
};

export const newObservation = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/observation/add', {...formValues});
    dispatch({type: NEW_OBSERVATION, payload: response.data});  
}

export const editObservation = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/observation/update/${id}`, {...formValues});
    dispatch({type: EDIT_OBSERVATION, payload: response.data});  
}

export const deleteObservation = (id) => async dispatch => {
    const response = await caredevo.delete(`/observation/${id}`);
    dispatch({type: DELETE_OBSERVATION, payload : response.data});
};


// Pathology
export const fetchPathologys = (ptid) => async dispatch => {
    const response = await caredevo.get(`/pathology/patient/${ptid}`);
    dispatch({type: FETCH_PATHOLOGYS, payload : response.data});
};

export const fetchPathology = (id) => async dispatch => {
    const response = await caredevo.get(`/pathology/${id}`);
    dispatch({type: FETCH_PATHOLOGY, payload : response.data});
};

export const newPathology = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/pathology/add', {...formValues});
    dispatch({type: NEW_PATHOLOGY, payload: response.data});  
}

export const editPathology = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/pathology/update/${id}`, {...formValues});
    dispatch({type: EDIT_PATHOLOGY, payload: response.data});  
}

export const deletePathology = (id) => async dispatch => {
    const response = await caredevo.delete(`/pathology/${id}`);
    dispatch({type: DELETE_PATHOLOGY, payload : response.data});
};

// Weight
export const fetchWeights = (ptid) => async dispatch => {
    const response = await caredevo.get(`/home_weight/patient/${ptid}`);
    dispatch({type: FETCH_HOMEWEIGHTS, payload : response.data});
};

export const fetchWeight = (id) => async dispatch => {
    const response = await caredevo.get(`/home_weight/${id}`);
    dispatch({type: FETCH_HOMEWEIGHT, payload : response.data});
};

export const newWeight = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/home_weight/add', {...formValues});
    dispatch({type: NEW_HOMEWEIGHT, payload: response.data});  
}

export const editWeight = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/home_weight/update/${id}`, {...formValues});
    dispatch({type: EDIT_HOMEWEIGHT, payload: response.data});  
}

export const deleteWeight = (id) => async dispatch => {
    const response = await caredevo.delete(`/home_weight/${id}`);
    dispatch({type: DELETE_HOMEWEIGHT, payload : response.data});
};

// Glucose
export const fetchGlucoses = (ptid) => async dispatch => {
    const response = await caredevo.get(`/home_glucose/patient/${ptid}`);
    dispatch({type: FETCH_HOMEGLUCOSES, payload : response.data});
};

export const fetchGlucose = (id) => async dispatch => {
    const response = await caredevo.get(`/home_glucose/${id}`);
    dispatch({type: FETCH_HOMEGLUCOSE, payload : response.data});
};

export const newGlucose = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/home_glucose/add', {...formValues});
    dispatch({type: NEW_HOMEGLUCOSE, payload: response.data});  
}

export const editGlucose = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/home_glucose/update/${id}`, {...formValues});
    dispatch({type: EDIT_HOMEGLUCOSE, payload: response.data});  
}

export const deleteGlucose = (id) => async dispatch => {
    const response = await caredevo.delete(`/home_glucose/${id}`);
    dispatch({type: DELETE_HOMEGLUCOSE, payload : response.data});
};

// BP
export const fetchBPs = (ptid) => async dispatch => {
    const response = await caredevo.get(`/home_bp/patient/${ptid}`);
    dispatch({type: FETCH_HOMEBPS, payload : response.data});
};

export const fetchBP = (id) => async dispatch => {
    const response = await caredevo.get(`/home_bp/${id}`);
    dispatch({type: FETCH_HOMEBP, payload : response.data});
};

export const newBP = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/home_bp/add', {...formValues});
    dispatch({type: NEW_HOMEBP, payload: response.data});  
}

export const editBP = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/home_bp/update/${id}`, {...formValues});
    dispatch({type: EDIT_HOMEBP, payload: response.data});  
}

export const deleteBP = (id) => async dispatch => {
    const response = await caredevo.delete(`/home_bp/${id}`);
    dispatch({type: DELETE_HOMEBP, payload : response.data});
};

/////////////////// Warning System

// Flag
export const fetchFlags = () => async dispatch => {
    const response = await caredevo.get('/flag');
    dispatch({type: FETCH_FLAGS, payload : response.data});
};

export const fetchFlag = (id) => async dispatch => {
    const response = await caredevo.get(`/flag/${id}`);
    dispatch({type: FETCH_FLAG, payload : response.data});
};

export const newFlag = (formValues) => async (dispatch) => {
    const response = await caredevo.post('/flag/add', {...formValues});
    dispatch({type: NEW_FLAG, payload: response.data});  
}

export const editFlag = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/flag/update/${id}`, {...formValues});
    dispatch({type: EDIT_FLAG, payload: response.data});  
}

export const deleteFlag = (id) => async dispatch => {
    const response = await caredevo.delete(`/flag/${id}`);
    dispatch({type: DELETE_FLAG, payload : response.data});
};

///// PHOTO Section


//photo_external
export const fetchPhotoExternals = (ptid) => async dispatch => {
    const response = await caredevo.get(`/photo_external/patient/${ptid}`);
    dispatch({type: FETCH_PHOTOEXTERNALS, payload : response.data});
};

export const fetchPhotoExternal = (id) => async dispatch => {
    const response = await caredevo.get(`/photo_external/${id}`);
    dispatch({type: FETCH_PHOTOEXTERNAL, payload : response.data});
};

export const newPhotoExternal = (formData) => async (dispatch) => {
    const response = await caredevo.post('/photo_external/add', formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
    });
    dispatch({type: NEW_PHOTOEXTERNAL, payload: response.data});  
}

export const editPhotoExternal = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/photo_external/update/${id}`, {...formValues});
    
    dispatch({type: EDIT_PHOTOEXTERNAL, payload: response.data});  
}

export const deletePhotoExternal = (id) => async dispatch => {
    const response = await caredevo.delete(`/photo_external/${id}`);
    dispatch({type: DELETE_PHOTOEXTERNAL, payload : response.data});
};

//photo_macro
export const fetchPhotoMacros = (sessionId) => async dispatch => {
    const response = await caredevo.get(`/photo_macro/${sessionId}`);
    dispatch({type: FETCH_PHOTOMACROS, payload : response.data});
};

export const fetchPhotoMacro = (id) => async dispatch => {
    const response = await caredevo.get(`/photo_macro/${id}`);
    dispatch({type: FETCH_PHOTOMACRO, payload : response.data});
};

export const newPhotoMacro = (formData) => async (dispatch) => {
    const response = await caredevo.post('/photo_macro/add', formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
    });
    dispatch({type: NEW_PHOTOMACRO, payload: response.data});  
}

export const editPhotoMacro = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/photo_macro/update/${id}`, {...formValues});
    dispatch({type: EDIT_PHOTOMACRO, payload: response.data});  
}

export const deletePhotoMacro = (id) => async dispatch => {
    const response = await caredevo.delete(`/photo_macro/${id}`);
    dispatch({type: DELETE_PHOTOMACRO, payload : response.data});
};

export const fetchShowMacro = (id) => async dispatch => {
    const response = await caredevo.get(`/photo_display/${id}`);
    dispatch({type: FETCH_SHOWMACRO, payload : response.data});
};

//photo_dermoscopy
export const fetchPhotoDermoscopys = (sessionId) => async dispatch => {
    const response = await caredevo.get(`/photo_dermoscopy/${sessionId}`);
    dispatch({type: FETCH_PHOTODERMOSCOPYS, payload : response.data});
};

export const fetchPhotoDermoscopy = (id) => async dispatch => {
    const response = await caredevo.get(`/photo_dermoscopy/${id}`);
    dispatch({type: FETCH_PHOTODERMOSCOPY, payload : response.data});
};

export const newPhotoDermoscopy = (formData) => async (dispatch) => {
    const response = await caredevo.post('/photo_dermoscopy/add', formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
    });
    dispatch({type: NEW_PHOTODERMOSCOPY, payload: response.data});  
}

export const editPhotoDermoscopy = (formValues, id) => async (dispatch) => {
    const response = await caredevo.post(`/photo_dermoscopy/update/${id}`, {...formValues});
    dispatch({type: EDIT_PHOTODERMOSCOPY, payload: response.data});  
}

export const deletePhotoDermoscopy = (id) => async dispatch => {
    const response = await caredevo.delete(`/photo_dermoscopy/${id}`);
    dispatch({type: DELETE_PHOTODERMOSCOPY, payload : response.data});
};

export const fetchShowDermoscopy = (id) => async dispatch => {
    const response = await caredevo.get(`/photo_display/${id}`);
    dispatch({type: FETCH_SHOWDERMOSCOPY, payload : response.data});
};

//photo Display
export const fetchPhotoDisplay = (id) => async dispatch => {
    const response = await caredevo.get(`/photo_display/${id}`);
    dispatch({type: FETCH_PHOTODISPLAY, payload : response.data});
};
